<div class="sort-by-container">
  <div class="top-container">
    <section class="filter-header">
      <h2>Ordenar por</h2>
    </section>
    <section class="filter-container">
      <div class="filter-field">
        <app-selector
          [activeColor]="'#04932f'"
          [label]="'Ordenar por'"
          [placeholder]="'Selecciona un campo'"
          [options]="fieldOptions"
          [(value)]="selectedField"
        ></app-selector>
      </div>
      <div class="filter-field">
        <app-selector
          [activeColor]="'#04932f'"
          [label]="'Criterio'"
          [placeholder]="'Selecciona un criterio'"
          [options]="criteriaOptions"
          [(value)]="selectedCriteria"
        ></app-selector>
      </div>
    </section>
  </div>
  <div class="bottom-container">
    <section class="actions">
      <button type="button" (click)="applySortCriteria()">
        <mat-icon> check </mat-icon>
        <div>Aplicar</div>
      </button>
      <button type="button" (click)="resetSortingCriteria()">
        <mat-icon> delete </mat-icon>
      </button>
    </section>
  </div>
</div>
